import React, { useState, useEffect } from 'react';

interface TimerProps {
  duration: number;
  onTimeUp: () => void;
  timerKey?: number;
}

const Timer: React.FC<TimerProps> = ({ duration, onTimeUp }) => {
  const [timeLeft, setTimeLeft] = useState(duration);

  useEffect(() => {
    setTimeLeft(duration);
  }, [duration]);

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timerId);
    } else {
      onTimeUp();
    }
  }, [timeLeft, onTimeUp]);

  const formatTime = () => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  // Calculate percentage of time remaining for visual indicator
  const timePercentage = (timeLeft / duration) * 100;
  const timerColor = timePercentage > 50 ? '#2ecc71' : 
                     timePercentage > 20 ? '#f39c12' : '#e74c3c';

  return (
    <div className="timer-container">
      <div className="timer" style={{ color: timerColor }}>
        Time left: {formatTime()}
      </div>
      <div className="timer-progress-container">
        <div 
          className="timer-progress" 
          style={{ 
            width: `${timePercentage}%`,
            backgroundColor: timerColor,
            height: '4px',
            borderRadius: '2px',
            transition: 'width 1s linear, background-color 1s ease'
          }}
        />
      </div>
    </div>
  );
};

export default Timer;
